import { createTheme, alpha } from '@mui/material/styles';

// Professional light theme with blue hero section
export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#0B38C9', // nis-ai.com primary blue
      light: '#1549f2',
      dark: '#043D75',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#0dd2e9', // nis-ai.com cyan accent
      light: '#5DEBF8',
      dark: '#0891b2',
      contrastText: '#ffffff',
    },
    background: {
      default: '#FAFAFA', // Light gray background
      paper: '#ffffff', // White cards
    },
    text: {
      primary: '#1a1a2e', // Dark text on light
      secondary: '#64748b', // Gray secondary text
    },
    error: {
      main: '#ef4444',
      light: '#f87171',
      dark: '#dc2626',
    },
    warning: {
      main: '#f59e0b',
      light: '#fbbf24',
      dark: '#d97706',
    },
    success: {
      main: '#10b981',
      light: '#34d399',
      dark: '#059669',
    },
    info: {
      main: '#06b6d4',
      light: '#22d3ee',
      dark: '#0891b2',
    },
    divider: alpha('#1a1a2e', 0.12),
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '2.5rem',
      lineHeight: 1.2,
      letterSpacing: '-0.02em',
    },
    h2: {
      fontWeight: 700,
      fontSize: '2rem',
      lineHeight: 1.3,
      letterSpacing: '-0.01em',
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.5rem',
      lineHeight: 1.4,
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.25rem',
      lineHeight: 1.4,
    },
    h5: {
      fontWeight: 600,
      fontSize: '1.1rem',
      lineHeight: 1.5,
    },
    h6: {
      fontWeight: 600,
      fontSize: '1rem',
      lineHeight: 1.5,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.6,
    },
    button: {
      fontWeight: 600,
      textTransform: 'none',
      letterSpacing: '0.02em',
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '10px 24px',
          fontSize: '0.95rem',
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(11, 56, 201, 0.4)',
          },
        },
        containedPrimary: {
          background: 'linear-gradient(135deg, #0B38C9 0%, #043D75 100%)',
          '&:hover': {
            background: 'linear-gradient(135deg, #1549f2 0%, #0B38C9 100%)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          borderRadius: 16,
          border: '1px solid rgba(0, 0, 0, 0.08)',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
            backgroundColor: alpha('#f8fafc', 0.8),
            '& fieldset': {
              borderColor: alpha('#1a1a2e', 0.2),
            },
            '&:hover fieldset': {
              borderColor: alpha('#1a1a2e', 0.4),
            },
            '&.Mui-focused fieldset': {
              borderColor: '#0B38C9',
            },
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 6,
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          height: 8,
          backgroundColor: alpha('#1a1a2e', 0.1),
        },
        bar: {
          borderRadius: 4,
          background: 'linear-gradient(135deg, #0B38C9 0%, #0dd2e9 100%)',
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
  },
});
